import { render, staticRenderFns } from "./FiscalDocumentDetail.vue?vue&type=template&id=5d3a21d0"
import script from "./FiscalDocumentDetail.vue?vue&type=script&lang=js"
export * from "./FiscalDocumentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports